export enum BuyerVenueTypesDialogPage {
  FIRST,
  SECOND,
}
